export interface IInformationBoxItem {
    label: string;
    data: string | undefined;
}

export interface IInformationBoxParams {
    title: string;
    items: Array<IInformationBoxItem>;
}

export default function InformationBox(params: IInformationBoxParams) {
    return (
        <div className="information-box">
            <h6>{params.title}</h6>

            <div className="body">
                {params.items.map((item, index) => (
                    <p key={index}>
                        <span>{item.label}: </span>
                        {item.data}
                    </p>
                ))}
            </div>
        </div>
    );
}